import './App.css';

function Oct27() {
    return (
        <>
        <div className='blog-post'>
            <div className='datestyle h3 '>Oct27st</div>
                <p>Wait - you haven't heard of Catblog?</p>
                <p>My amazing 10yo daughter and I CATalog our favorite online beasts here - check it out</p>
                <br></br>
                <p>Its an excuse to hang with my bae, look at sweet cats and learn REACT.  Checkout the API integrations!</p>
                <p></p>
                <a href="https://evescatblog.netlify.app/">CatBlog!</a><p></p>
                <a href="https://github.com/kennyvigar/someSQLStuff/blob/main/SQLBackupReport.ps1">Kenny's Github (featuring Eve!)</a>
        </div>
        </>
    );
}

export default Oct27;